import { useQueryClient } from '@tanstack/react-query';
import { refreshCallContext as refreshCallContextQuery } from './queries/call-context';

export function GetCookie(cname: string): string {
  const name = `${cname}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
    if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
  }
  return 'fout';
}

export const getFormField = (form: any, categoryName: string, key: string): any => {
  const category = form.categories.find((candidate: any) => candidate.name === categoryName);
  return category?.fields?.find((field: any) => field.key === key);
};

export const rowTotal = (key: string, record: any): number => record.voerLeveringRows.reduce((total: number, row: any) => total + (row[key] ?? 0), 0);

export const removeItemFromCollection = <T>(record: T, dataSource: T[], setDatasource: (items: T[]) => void): void => {
  const items = [...dataSource];
  const index = items.indexOf(record);
  if (index !== -1) {
    items.splice(index, 1);
    setDatasource(items);
  }
};

export const useRefreshMenu = () => {
  const queryClient = useQueryClient();
  const refreshMenu = () => queryClient.invalidateQueries({ queryKey: ['Menu'] });
  const refreshCallContext = () => refreshCallContextQuery(queryClient);
  const refreshVoorwaarden = () => queryClient.invalidateQueries({ queryKey: ['Voorwaarden'] });
  return { refreshMenu, refreshCallContext, refreshVoorwaarden };
};
